export default "__VITE_ASSET__DrQqKmRE__"